import { EntityInner } from "../configurator/types";

const fieldstoExclude = ["submit", "formErrors", "cancel", "virtualField"];

const checkClientFieldsPre = (clientFields: string[]) => (field: string, path?: string) =>
  clientFields.includes(path ? path : field) ? `${field} @client` : field;

const getFields = ({
  usedFields,
  requiredFields,
  usedMappingInfos,
  clientFields,
  externalFields,
  entity,
  usedFieldTypes,
}: {
  entity: string;
  usedFields: string[];
  requiredFields: string[];
  usedMappingInfos: EntityInner[];
  clientFields: string[];
  externalFields: string[];
  usedFieldTypes: { [key: string]: string };
}) => {
  // console.log({
  //   usedFields,
  //   requiredFields,
  //   usedMappingInfos,
  //   clientFields,
  //   externalFields,
  //   entity,
  // });
  const checkClientFields = checkClientFieldsPre(clientFields),
    mappingToCache: string[] = [],
    fields: string[] = usedFields
      .concat(requiredFields)
      .filter((x, i, a) => a.indexOf(x) == i && !externalFields.includes(x))
      .map((field) => {
        const mappingInfoPre = usedMappingInfos.find((mappingInfo) => Object.keys(mappingInfo)[0] === field);
        if (mappingInfoPre) {
          // @ts-ignore
          const mappingInfo = mappingInfoPre[field];

          const fields = Object.entries(mappingInfo.fields).reduce((list: string[], [key, value]) => {
            //   console.log(key);
            if (!Object.values(mappingInfo.mappingIds).includes(key)) {
              if (value !== "nested") {
                return list.concat(checkClientFields(key, `${field}.${key}`));
              }
              //  return list.concat(key);
            }
            //  console.log(list);
            return list;
          }, []);
          const mappingIds = Object.entries(mappingInfo.mappingIds).map(([key, value]) => {
            return `${key}:${value}`;
          });

          Object.keys(mappingInfo.mappings).forEach((mapping) => {
            mappingIds.push(`mapping: ${mapping}{\n\t\t\t\tid\n\t\t\t\ttranslationKey\n\t\t\t}`);
            mappingToCache.push(`${mapping}{\n\t\t\t\tid\n\t\t\t\ttranslationKey\n\t\t\t}`);
          });
          return `${field}{\n\t\t\t${mappingIds.concat(fields).join(",\n\t\t\t")}\n\t\t}`;
        }
        if (usedFieldTypes[field] === "GeoJSONPolygonType") return `${field}{\n\t\t\tcoordinates\n\t\t\t}`;

        return checkClientFields(field, `${entity}.${field}`);
      });
  return { fields: ["id"].concat(fields), mappingToCache };
};

export default (
  { entity, usedFields, requiredFields, usedMappingInfos, usedFieldTypes, ...rest }: any,
  clientFields: string[],
  externalFields: string[],
  useHC11: boolean
) => {
  const { fields, mappingToCache } = getFields({
    usedFields: usedFields.filter((field: string) => !fieldstoExclude.includes(field)),
    requiredFields,
    usedMappingInfos,
    clientFields,
    externalFields,
    entity,
    usedFieldTypes,
  });

  const idName = "id";
  const uuidName = useHC11 ? `Uuid` : "UUID";

  const query = `query Raftget${entity}($id: ${uuidName}!) {\n\tresult : ${entity}(id: $id) {\n\t\t${fields.join(
    // const query = `query get${entity}($id: Int!) {\n\tresult : ${entity}(id: $id) {\n\t\t${fields.join(
    ",\n\t\t"
  )}\n\t}${mappingToCache.join("\n\n")}\n}
       
   `;
  return query;
};
